import { defineMessages } from "react-intl";

export default defineMessages({
  companyName: {
    id: "Copyright.companyName",
    defaultMessage: "{companyLegalName}",
  },
  iban: {
    id: "Copyright.iban",
    defaultMessage: "{companyIban}",
  },
  years: {
    id: "Copyright.years",
    defaultMessage: "© {companyStartingYear}-{currentYear}",
  },
  termsAndConditions: {
    id: "Copyright.termsAndConditions",
    defaultMessage: "Terms and Conditions",
  },
  sitemap: {
    id: "Copyright.sitemap",
    defaultMessage: "Sitemap",
  },
});
